import { defineStore } from 'pinia'

export const useCheckboxListStore = defineStore('checkboxList', {
  state: () => {
    return {
      lists: {},
    }
  },
  getters: {
    listSize(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return 0;
        return state.lists[list].values.length;
      };
    },
    isChecked(state) {
      return (id, list = 'default') => {
        const index = state.lists[list].values.indexOf(id);
        if (index === -1) return false;
        return state.lists[list].checked[index] || false;
      }
    },
    checkedIds(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return [];
        return state.lists[list].values.filter((id, index) => state.lists[list].checked[index] === true);
      }
    },
    checkedCount(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return 0;
        return state.checkedIds(list).length;
      };
    },
    rangeSelectionMode(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return 'none';
        return state.lists[list].rangeSelectionMode;
      }
    },
    lastChangedId(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return null;
        return state.lists[list].lastChangedId;
      }
    },
    lastMouseEnterId(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return null;
        return state.lists[list].lastMouseEnterId;
      }
    },
    lastChangedIndex(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return -1;
        const lastChangedId = state.lastChangedId(list);
        if (lastChangedId === null) return -1;
        return state.lists[list].values.indexOf(lastChangedId);
      }
    },
    lastMouseEnterIndex(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return -1;
        const lastMouseEnterId = state.lastMouseEnterId(list);
        if (lastMouseEnterId === null) return -1;
        return state.lists[list].values.indexOf(lastMouseEnterId);
      }
    },
    nothingSelected(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return true;
        return state.checkedIds(list).length === 0;
      };
    },
    allSelected(state) {
      return (list = 'default') => {
        if (state.lists[list] === undefined) return false;
        return state.lists[list].all === true;
      };
    },
  },

  actions: {
    initList(list, values) {
      this.lists[list] = {
        values: values,
        all: false,
        rangeSelectionMode: 'none',
        lastChangedId: null,
        lastMouseEnterId: null,
        checked: [],
      };
    },

    setAll(all, list) {
      this.lists[list].all = all;
    },

    applyAll(all, list) {
      this.setAll(all, list);
      this.toggleAll(list);
    },

    toggleAll(list) {
      const all = this.lists[list].all;
      this.lists[list].values.forEach((id) => {
        if (all) {
          this.check(id, list);
          return;
        }
        this.uncheck(id, list);
      });
      this.resetRangeSelection(list);
    },

    toggle(id, list) {
      if (!this.isChecked(id, list)) {
        this.check(id, list);
      } else {
        this.uncheck(id, list);
      }
    },

    check(id, list) {
      const index = this.lists[list].values.indexOf(id);
      if (index === -1) return;

      this.lists[list].checked[index] = true;
    },

    uncheck(id, list) {
      const index = this.lists[list].values.indexOf(id);
      if (index === -1) return;

      this.lists[list].checked[index] = false;
    },

    setRangeSelectionMode(mode, list) {
      this.lists[list].rangeSelectionMode = mode;
    },

    setLastChangedId(id, list) {
      this.lists[list].lastChangedId = id;
    },

    setLastMouseEnterId(id, list) {
      this.lists[list].lastMouseEnterId = id;
    },

    resetRangeSelection(list) {
      this.setRangeSelectionMode('none', list);
      this.setLastChangedId(null, list);
    },
  }
})
